






























































import { Component, Vue } from 'vue-property-decorator';
import { FORMAT_CURRENCY } from '@/utils/formatPrice';
import Loading from '@/components/Loading.vue';
import { IInvoice } from '@/interfaces/IInvoice';
import { GetterNames } from '@/constants/GetterNames';
import { ActionNames } from '@/constants/ActionNames';
import * as moment from 'moment';

@Component({
  components: {
    Loading,
  },
})
export default class InvoiceList extends Vue {
  public date = moment;

  public loading: boolean = true;

  public currentMonth: string | null = null;

  public error: {
    type: string,
    message: string,
    show: boolean,
  } = {
    show: false,
    type: '',
    message: '',
  };

  public formatCurrency = (price: number): string => FORMAT_CURRENCY(price);

  get allOrders(): IInvoice[] {
    return this.$store.getters[GetterNames.INVOICES];
  }

  public async mounted() {
    const success = await this.$store.dispatch(ActionNames.INVOICES);

    if (!success) {
      this.error = {
        show: true,
        type: 'warning',
        message: 'Er ging iets mis tijdens het ophalen van je facturen',
      };

      return;
    }

    this.currentMonth = this.date().format('YYYY-MM-DD');
    this.loading = false;
  }

  public async paginate(months: number) {
    this.loading = true;
    this.currentMonth = this.date(this.currentMonth).add(months, 'months').format('YYYY-MM-DD');
    const success = await this.$store.dispatch(ActionNames.INVOICES, this.currentMonth);

    if (!success) {
      this.error = {
        show: true,
        type: 'warning',
        message: 'Er ging iets mis tijdens het ophalen van je facturen',
      };
    }

    this.loading = false;
  }

  public async getInvoice(invoiceId: number) {
    this.loading = true;

    const success = await this.$store.dispatch(ActionNames.CREATE_INVOICE, invoiceId);

    if (!success) {
      this.error = {
        show: true,
        type: 'warning',
        message: 'Er ging iets mis tijdens het ophalen van de factuur',
      };

      this.loading = false;

      return;
    }

    this.error = {
      show: true,
      type: 'success',
      message: 'Uw factuur is aangemaakt en gedownload',
    };

    this.loading = false;
  }
}
